//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TransientObject.js";
import "../no/Dimensions.js";
let d=[[[0,"DualDimensionDecimalPlaces",1,0],[0,"DualToleranceDecimalPlaces",1,0],[0,"LimitFitAnsiHoleType",1,0],[0,"LimitFitDeviation",1,0],[0,"LimitFitDisplayStyle",1,0],[0,"LimitFitGrade",1,0],[0,"PrimaryDimensionDecimalPlaces",1,0],[0,"ToleranceType",1,0],[0,"ZeroToleranceDisplayStyle",1,0]],[[[],"Dispose",{},0,0],[[],"GetUpperToleranceInches",{R_:{upper_tolerance_inches:''}},0,0],[["upper_tolerance_inches"],"SetUpperToleranceInches",{},1,0],[[],"GetLowerToleranceInches",{R_:{lower_tolerance_inches:''}},0,0],[["lower_tolerance_inches"],"SetLowerToleranceInches",{},1,0],[[],"GetUpperToleranceMm",{R_:{upper_tolerance_mm:''}},0,0],[["upper_tolerance_mm"],"SetUpperToleranceMm",{},1,0],[[],"GetLowerToleranceMm",{R_:{lower_tolerance_mm:''}},0,0],[["lower_tolerance_mm"],"SetLowerToleranceMm",{},1,0]],[]];
SPLM.Annotations.LinearTolerance = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.LinearTolerance";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;